import React from 'react'
import Navbar from 'react-bootstrap/Navbar'

import Link from '@/components/link/link'
import MenuTop from '@/components/navigation/menu-top'
import Navigation from '@/components/navigation/navigation'
import { MenuProvider } from '@/components/navigation/useMainMenu' // Importa el hook de contexto
import LinkGlobalNtt from '@/components/link-global-ntt/link-global-ntt'

const PageHeader = ({ location, showNavigation = true }) => {
  return (
    <header className="main-header">
      <div id="header">
        <div className="pre-header d-none d-lg-block">
          <div className="container">
            <div className="col-branding">
              <Navbar.Brand href="/">
                <img
                  src="/media/header_logo.svg"
                  alt="logo ntt data"
                  width="150"
                  height="35"
                />
              </Navbar.Brand>
              <div className="title-menu">INSURANCE</div>
            </div>
            <MenuTop />
          </div>
        </div>
        <Navbar expand="lg" className="container">
          <Navbar.Brand href="/" className="d-lg-none brand-mobile">
            <img
              src="/media/header_logo.svg"
              alt="logo ntt data"
              width="140"
              height="28"
            />
            <div className="title-menu">INSURANCE</div>
          </Navbar.Brand>
          <LinkGlobalNtt />
          <div className="logo-scroll">
            <Link to="/">
              <img src="/media/header_logo.svg" alt="logo ntt data" />
            </Link>
            <div className="title-menu">INSURANCE</div>
          </div>
          {showNavigation && (
            <MenuProvider location={location}>
              <Navigation />
            </MenuProvider>
          )}
        </Navbar>
      </div>
    </header>
  )
}

export default PageHeader
